/**
 * Application Constants
 * Shared business rules and configuration across mobile and web
 */

/**
 * Default values for company creation and configuration
 */
export const COMPANY_DEFAULTS = {
  /** Default maximum users (Manager + Staff) for new companies */
  MAX_USERS: 10,
} as const;

/**
 * Password generation and validation configuration
 */
export const PASSWORD_CONFIG = {
  /** Minimum password length */
  MIN_LENGTH: 6,
  /** Length of generated temporary passwords */
  GENERATED_LENGTH: 12,
  /** Character sets for password generation */
  CHARSET: {
    UPPERCASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    LOWERCASE: "abcdefghijklmnopqrstuvwxyz",
    NUMBERS: "0123456789",
    SYMBOLS: "!@#$%^&*",
  },
} as const;

/**
 * System email configuration
 */
export const SYSTEM_EMAIL = {
  /** System sender email address (verified on Resend) */
  ADDRESS: "admin@spechs.ie",
  /** System sender display name */
  NAME: "Spechs Admin",
} as const;
